import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema, BillingVendorSchema } from '../base/bill.js';
export const CreateBillApiSchema = {
    body: BillSchema.pick({ total: true }).extend({
        vendor: BillingVendorSchema.omit({ id: true, name: true }),
    }),
    params: z.object({
        entityId: CornSchema,
    }),
    headers: z.object({ requestActor: z.string() }),
    response: BillSchema.optional(),
};
export const CreateBillPathSchema = CreateBillApiSchema.params;
export const CreateBillHeadersSchema = CreateBillApiSchema.headers;
export const CreateBillBodySchema = CreateBillApiSchema.body;
export const CreateBillRequestSchema = CreateBillBodySchema.merge(CreateBillHeadersSchema).merge(CreateBillPathSchema);
export const CreateBillResponseSchema = CreateBillApiSchema.response;
